import { object } from 'prop-types';
import { useNavigate } from 'react-router-dom';

import { Badge, SanitizedHtml, StrapiImg } from 'components';
import { routes } from 'router';

import 'assets/styles/components/deals/deals-list.scss';

const DealCard = ({ deal }) => {
  const navigate = useNavigate();

  return (
    <div className="deal-item relative" onClick={() => navigate(`${routes.deals.path}/${deal.id}`)}>
      <div className="image-container">
        <StrapiImg image={deal.thumbnail} className="w-full h-full object-cover" />

        <StrapiImg image={deal.logo} className="absolute w-24 h-12 lg:w-32 lg:h-16 bottom-2 left-2" />
      </div>

      <div className="content-container">
        {deal.thumbnailBadge && (
          <div className="lg:top-5 lg:right-5 flex lg:absolute">
            <Badge color="dark-yellow" className="small">
              {deal.thumbnailBadge}
            </Badge>
          </div>
        )}
        <h2 className="h3 truncate-line one-line">{deal.title}</h2>
        <hr className="w-18 border-t-yellow-500 border-t-[0.13rem]" />
        <h3 className="h4">{deal.subtitle}</h3>
        <SanitizedHtml content={deal.description} className="text-sm lg:text-base truncate-line four-lines" />
        <hr className="w-18 border-t-yellow-500 border-t-[0.13rem]" />
        <div className="flex justify-between items-center">{deal.availableText}</div>
      </div>
    </div>
  );
};

DealCard.propTypes = {
  deal: object.isRequired
};

export default DealCard;
